import {RouterView} from "vue-router";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";

const Profile = () => import('@/views/user/Profile.vue')

const userRoutes = [
    {
        path: 'profilo',
        name: 'Il tuo profilo',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'profile',
                component: Profile,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            }
        ]
    },
];

export default userRoutes;